// Log estruturado e legível de erros do front-end. Sem lib nova: usa console
// do navegador, mas com formato consistente para facilitar leitura/triagem
// (o que aconteceu, onde, e o erro original) tanto em dev quanto em produção
// (DevTools do cliente).
export type ErrorSource = 'react-boundary' | 'query' | 'mutation' | 'window' | 'unhandled-rejection';

export function logFrontendError(source: ErrorSource, context: Record<string, unknown>, error: unknown): void {
  const err = error instanceof Error ? error : new Error(String(error));
  console.error(
    `[apto:${source}] ${err.message}`,
    { ...context, name: err.name, stack: err.stack },
  );
}
